<script>
// Base mixin providing a "variant" prop and the matching style lookup.
// Components using it must override the `variantStyles` data property.
export default {
  props: {
    disabled: { default: false },
    variant: {
      default: "default",
      validator: (variant) =>
        ["default", "disabled", "success", "warning", "danger"].includes(
          variant,
        ),
    },
  },

  data() {
    return {
      variantStyles: {
        default: "not implemented",
        disabled: "",
        success: "",
        warning: "",
        danger: "",
      },
    };
  },

  computed: {
    variantStyle() {
      return this.disabled
        ? this.variantStyles.disabled
        : this.variantStyles[this.variant];
    },
  },

  mounted() {
    //? Not possible to make component and property abstract so we do it like this
    if (this.variantStyles.default === "not implemented") {
      throw "Component extending BaseVariantComponent must overload variantStyles-property";
    }
  },
};
</script>
